const PATHS = {
  home: '/:token/',
  guestRegistration: 'guest/registration',
  addPersonalDataForm: 'add/guest',
  faq: 'faq',
  taxes: {
    main: 'taxes',
    exemptions: 'exemptions',
  },
  verification: {
    main: 'verification',
    documentSelection: 'document-selection',
    qrScan: 'qr-scan',
    front: 'front',
    back: 'back',
    selfie: 'selfie',
    contacts: 'contacts',
  },
  deposits: 'deposit',
  payments: {
    main: 'payments',
    ordersHistory: 'order-history',
  },
  checkout: {
    main: 'checkout',
    rateYourStay: 'rate-your-stay',
    thanks: 'thanks-for-your-stay',
  },
  recommendations: {
    main: 'recommendations',
    requests: 'requests',
    requestsFull: 'recommendations/requests',
    details: {
      main: ':id',
    },
  },
  remoteAccess: 'remote-access',
  luggage: 'luggage-storage',
  searchReservation: {
    main: 'booking-search',
    bookingCode: 'booking-search/code',
    checkingDate: 'booking-search/date',
    guestName: 'booking-search/guest-name',
    newReservation: 'new-reservation',
    directReservation: 'direct-reservation',
    welcomeScreen: 'welcome-screen',
  },
  guidebook: 'guidebook',
  guidebookHtml: 'guidebook-html',
  guidebookPdf: 'guidebook-pdf',
  housingGuidebooks: 'housing-guidebooks',
  auth: {
    root: 'auth',
    createAccount: 'create-account',
    login: 'login',
    welcome: 'welcome',
  },
  oauth: {
    root: 'oauth',
    google: 'oauth/google',
  },
  onboarding: {
    root: 'onboarding',
    reservationType: 'reservation-type',
    numberOfGuests: 'number-of-guests',
    confirmLeaderGuest: 'confirm-leader-guest',
    whoIsComing: 'who-is-coming',
  },
  esim: {
    root: 'esim',
    manage: 'esim/manage',
    choosePlan: 'esim/choose-plan',
    my: 'esim/my',
    help: 'esim/my/help',
  },
  verifyOnHousing: 'verify-on-housing',
  findReservationsByName: 'find-reservations-by-name',
  chat: 'chat',
  travelGuide: 'travel-guide',
};

const RECOVERY_ROUTE_SEGMENTS = [
  ...Object.values(PATHS.searchReservation),
  PATHS.findReservationsByName,
  PATHS.verifyOnHousing,
];

const isRecoveryPathname = (pathname: string) => {
  const pathSegments = pathname.split('/').filter(Boolean);
  return RECOVERY_ROUTE_SEGMENTS.some(segment => pathSegments.includes(segment));
};

const verificationTypesRoutes = [
  PATHS.verification.main,
  `${PATHS.verification.main}/:id`,
];
const addPersonalDataFormRoute = [
  PATHS.addPersonalDataForm,
  `${PATHS.addPersonalDataForm}/:id`,
];

const FIND_BOOKING_ROUTES = Object.values(PATHS.searchReservation);

const AUTH_LOGIN_ROUTE = `${PATHS.auth.root}/${PATHS.auth.login}`;

export {
  PATHS,
  AUTH_LOGIN_ROUTE,
  addPersonalDataFormRoute,
  verificationTypesRoutes,
  FIND_BOOKING_ROUTES,
  isRecoveryPathname,
};
